import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function City() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [country, setCountry] = useState({});

  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/countries/${memberId}`
        );
        setCountry(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchCountries();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">Country Details</h1>
        <Link to={'/edit-country/' + memberId}>
          <button className="memberAddButton">Edit</button>
        </Link>
      </div>
      <h3 className="box-title">Country Name</h3>
      <hr />
      <div className="memberContainer">
        <div className="memberShow">
          <div className="memberShowBottom">
            <div className="memberShowInfo">
              <span className="memberShowInfoLabel">Name:</span>{' '}
              <span className="memberShowInfoTitle">
                {country.country_name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
